import React, { useEffect } from 'react';
import { BlockWrapper, ChildrenBlock, smartProps, useEditor, defineBlock } from '@smartfire/glue-ui/block';
import { EditableText } from '@smartfire/components';
import { InnerBlocks } from '@wordpress/block-editor';
import { TemplateArray } from '@wordpress/blocks';
import Swiper, { Pagination } from 'swiper';
import clsx from 'clsx';
import 'swiper/swiper.min.css';
import 'swiper/components/pagination/pagination.scss';
import style from './style.module.scss';

Swiper.use([Pagination]);

function HowItWorks() {
    const { isEditing } = useEditor();

    const TEMPLATE_BLOCKS: TemplateArray = [['smartfire/how-it-works-step']];
    const ALLOWED_BLOCKS: string[] = ['smartfire/how-it-works-tile'];

    useEffect(() => {
        const timer = setTimeout(() => {
            new Swiper('.swiper', {
                slidesPerView: 1,
                spaceBetween: 20,
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    992: {
                        slidesPerView: 5,
                        spaceBetween: 50,
                    },
                },
                observeSlideChildren: true,
                watchOverflow: true,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                },
            });
        }, 1000);
        return () => clearTimeout(timer);
    }, []);

    return (
        <BlockWrapper.Section className={clsx(style.block, 'full-width')}>
            <EditableText className={style.title} smartProp="title" tagName="h2" placeholder="Titre" />
            <EditableText className={style.subtitle} smartProp="subtitle" tagName="h3" placeholder="Sous-titre" />
            {isEditing ? (
                <div className={style.steps}>
                    <InnerBlocks template={TEMPLATE_BLOCKS} allowedBlocks={ALLOWED_BLOCKS} />
                </div>
            ) : (
                <div className={clsx(style.steps, 'swiper', 'swiper-container')}>
                    <ol className={'swiper-wrapper'}>
                        <ChildrenBlock childrenBlockComponent={React.Fragment} />
                    </ol>
                    <div className={clsx(style.bullets, 'swiper-pagination')} />
                </div>
            )}
        </BlockWrapper.Section>
    );
}

export default defineBlock({
    Block: HowItWorks,
    smartProps: {
        title: smartProps.string.withDefault(''),
        subtitle: smartProps.string.withDefault(''),
    },
    setup: {
        title: 'Comment ça marche',
    },
});
